/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 8/1/13
 * Time: 9:38 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var KEYS = {
        CURSORSTART: "cursorStart",
        CURSOREND: "cursorEnd"
    };

    var TextareaFieldModel = Backbone.Model.extend({
        defaults : {
            value: "",
            placeholder:"",
            maxChars: 300,
            cursorStart:  null,
            cursorEnd: null,
            enableCounter: false
        },
        validation: {
            value: [
                {
                    required: false,       //BB validations sucks does not allow string with 0 length need to put required on false for that
                    maxLength: 300,
                    msg: {
                        key: "LEUIComponents.errors.illegalInput.inputToLong"
                    }
                }
            ]
        },
        initialize : function () {
        },


        validate : function (val) {
            var maxLength = this.get("maxChars");
            this.validation.value[0].maxLength = maxLength;
            this.validation.value[0].msg.args =  [maxLength];

            return this.preValidate("value",val);
        },

        reset : function () {
        },

        setCursorPosition: function(start, end){
            this.set(KEYS.CURSORSTART, start);
            this.set(KEYS.CURSOREND, end);
        },
        resetCursor: function(){
            this.setCursorPosition(null, null);
        },
        getCursorStart: function(){
            return this.get(KEYS.CURSORSTART);
        },
        getCursorEnd: function(){
            return this.get(KEYS.CURSOREND);
        }

    });

    return TextareaFieldModel;
});

